An array of further divisions of the country.

These may include districts, regions, states, provinces, etc.

A maximum of 5 subdivisions may be provided.
